import {
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
  ChoiceGroup,
  Toggle,
  TooltipHost,
  Icon,
  DefaultButton,
} from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CreateHearingTypePanel = ({
  isOpen,
  onClose,
  hearingTypeName,
  setHearingTypeName,
  onConfirmCreateHearingType,
  isCreatingHearingType,
  hearingTemplateOptions,
  setHearingTemplateId,
  hearingTemplateId,
  setIsInternal,
  isInternal,
}) => {
  const { t: translator } = useTranslation();
  const onTextChange = (_, value) => setHearingTypeName(value);
  const onSelection = (_, option) => setHearingTemplateId(option.key);
  const onToggle = () => {
    setIsInternal(!isInternal);
  };

  return (
    <div>
      <Panel
        isOpen={isOpen}
        type={PanelType.medium}
        onDismiss={isCreatingHearingType || onClose}
        isLightDismiss={true}
        onOuterClick={(_) => null}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <h3 className="panel-header">
            {translator('pages.adminHearingTypes.addHearingType')}
          </h3>
          <TextField
            label={translator('global.name')}
            value={hearingTypeName}
            onChange={onTextChange}
          />
          <div style={{ paddingTop: '10px' }}>
            <Toggle
              label={
                <div style={{ fontWeight: 500, fontSize: 16 }}>
                  {translator('hearingProperties.internalHearing')}
                  {'? '}
                  <TooltipHost
                    content={translator(
                      'pages.adminHearingTypes.isInternalGuide',
                    )}
                  >
                    <Icon iconName="Info" aria-label="Info tooltip" />
                  </TooltipHost>
                </div>
              }
              onText={translator('global.yes')}
              offText={translator('global.no')}
              onChange={onToggle}
            />
          </div>
          <div style={{ paddingTop: '4px' }}>
            <p style={{ fontWeight: 500, fontSize: 16 }}>
              {translator('pages.adminHearingTypes.chooseLayout')}
            </p>
            <p>{translator('pages.adminHearingTypes.chooseLayoutGuide')}</p>
            <div className="hearing-type-panel-hearing-templates">
              <ChoiceGroup
                options={hearingTemplateOptions}
                onChange={onSelection}
              />
            </div>
          </div>
          <div className="panel-buttons">
            {isCreatingHearingType && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onClose}
              disabled={isCreatingHearingType}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirmCreateHearingType}
              disabled={
                isCreatingHearingType ||
                hearingTemplateId === null ||
                hearingTypeName === ''
              }
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { CreateHearingTypePanel };
